import { assign, map } from 'lodash';
import request from '../utils/request';

const files = require.context('./pagesApi', true, /\.js$/);
const generators = files.keys().map(key => files(key).default);

export default assign({}, ...map(generators, generator => generator({ request })));